import { Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';

export const KQuickCalendar = ({
  options = [],
  selected = { id: '' },
  onChange = (view) => {},
}) => {
  return (
    <Box p="12px">
      {options?.map((view) => {
        const bg = selected?.id === view?.id ? '#F9FAFB' : '#FFFFFF';
        return (
          <KText
            key={view?.id}
            px="16px"
            py="10px"
            size={'sm-medium'}
            _hover={{ bg: '#F9FAFB' }}
            cursor="pointer"
            borderRadius="sm"
            bg={bg}
            onClick={() => {
              onChange(view);
            }}
          >
            {view?.label}
          </KText>
        );
      })}
    </Box>
  );
};
